import { render } from "./CustomSelect2.vue?vue&type=template&id=1f0f9c91&scoped=true"
import script from "./CustomSelect2.vue?vue&type=script&lang=js"
export * from "./CustomSelect2.vue?vue&type=script&lang=js"

import "./CustomSelect2.vue?vue&type=style&index=0&id=1f0f9c91&lang=scss&scoped=true"
import "./CustomSelect2.vue?vue&type=style&index=1&id=1f0f9c91&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f9c91"]])

export default __exports__